export { SuiTabsModule } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/tabs/public.js
// module id = 1124
// module chunks = 0